import React from 'react';
import { CSVButton } from './CSVButton';

interface CSVExportProps {
  onExport: () => void;
  label?: string;
}

export const CSVExport: React.FC<CSVExportProps> = ({ onExport, label }) => {
  return <CSVButton type="export" onClick={onExport} label={label} />;
};